module.exports = __webpack_public_path__ + "img/avatar-m1.f51bd0c0.png";